import gql from 'graphql-tag';

export default gql`
  fragment EventFragment on Event {
    _id
    title
    dateTime
    color
    status
    creator {
      _id
    }
    data {
      users {
        _id
        firstName
        lastName
        email
        isActivated
        role
        courses {
          data {
            _id
          }
          lessonTemplate
          dbId
          notesAboutStudent
        }
      }
      studentsGroup
      lesson {
        _id
        id
        title
        alias
      }
      courseCategory {
        _id
        title
        alias
        categoryIndex
        data {
          color
          isCommonCourseCategory
          course
        }
      }
      course
    }
  }
`;
